<template>
	<b-modal :visible="show" @hide="() => this.$emit('close')" hide-footer :title="'Choose lessons' | translate">
		<form action="." method="post" class="text-center">
			<div class="table-responsive">
				<table class="table">
					<tr>
						<th>
							<input @change="checkAll" v-model="checkAllInput" type="checkbox" />
						</th>
						<th>{{ 'Lesson' | translate }}</th>
					</tr>
					<tr :key="lesson.id" v-for="lesson in listLessons">
						<td>
							<input v-model="checkedLessons" :value="lesson.id" type="checkbox" />
						</td>
						<td>
							{{ 'Lesson' | translate }} {{ lesson.order }}
							<router-link :to="{
								name: 'Dashboard Lesson',
								params: { id: lesson.id },
							}">{{ lesson.name_uk }}
							</router-link>
						</td>
					</tr>
				</table>
			</div>
			<button class="btn btn-primary" @click.prevent="assignLessons">
				{{ 'Save' | translate }}
			</button>
			<button class="btn btn-secondary" @click.prevent="$emit('close')">
				{{ 'Close' | translate }}
			</button>
		</form>
	</b-modal>
</template>

<script>
export default {
	name: 'modal-lessons',
	props: ['show'],
	data() {
		return {
			listLessons: [],
			checkedLessons: [],
			checkAllInput: false,
		}
	},
	methods: {
		checkAll() {
			this.checkedLessons = []
			if (this.checkAllInput) {
				this.listLessons.forEach(item => {
					this.checkedLessons.push(item.id)
				})
			}
		},
		assignLessons() {
			let role = this.$route.params.role === 'group' ? 'groups/' : 'users/user/'
			this.axios({
				method: 'post',
				url: `${role}${this.$store.state.modalId}/lessons`,
				data: {
					lessons: this.checkedLessons,
				},
			}).then(response => {
				this.$emit('close')
			})
		},
		getLessons() {
			this.checkedLessons = []
			let query =
				this.$route.params.role === 'student'
					? '?user=' + this.$store.state.modalId
					: '?group=' + this.$store.state.modalId
			this.axios({
				method: 'get',
				url: `lessons/${query}`,
			}).then(response => {
				this.listLessons = response.data
				this.listLessons.forEach(item => {
					item.is_active ? this.checkedLessons.push(item.id) : ''
				})
			})
		},
	},
	created() {
		this.getLessons()
	},
	watch: {
		show: function () {
			if (this.show) {
				this.getLessons()
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
	margin: 10px;
}

td {
	text-align: left;
}

.modal {
	overflow: scroll;
}
</style>
